<div class="timeout-modal" fxLayout="column">
    <div class="timeout-header" fxLayout="row" fxLayoutAlign="space-between">
        <div mat-dialog-title name="timeout-warning-title">Are you still there?</div>
        <button mat-icon-button [mat-dialog-close]="true" [disableRipple]="true" class="close-btn-modal" fxShow.md="false" fxShow.lg="false" fxShow.xl="false" fxShow="true">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="content" fxLayout="column">
        <div class="description" fxLayout="row" fxFlexOffset="34px">
            <div>
                <mat-icon>access_time</mat-icon>
            </div>
            <div>
                <p name="timeout-warning-desc">You have been inactive for 30 minutes and will be logged out in:</p>
            </div>
        </div>
        <div fxFlexOffset="20px" fxLayoutGap="13px" fxLayout="column" fxLayoutAlign="space-evenly">
            <div name="timeout-warning-countdown" *ngIf="countDown == 1;then secondTemplate else secondsTemplate"></div>
        </div>
    </mat-dialog-content>
</div>

<ng-template #secondsTemplate>
    <p class="timeout-countdown">{{countDown}} seconds</p>
</ng-template>
<ng-template #secondTemplate>
    <p class="timeout-countdown">{{countDown}} second</p>
</ng-template>